<template>
	<el-dialog
	  title="修改登录密码"
	  :modelValue="Visible"
	  @close="Admin_Update_Password_Hide()"
	  :width="460"
	>
		<div class="ModuleBox">
			<div class="ModuleBoxBody">
				<el-form :model="Form" :rules="Rules" ref="RefForm">
					<div class="ModuleBoxBodyOldPassword">
						<el-form-item label="旧密码" prop="OldPassword">
							<el-input
								type="password"
								v-model="Form.OldPassword"
								placeholder="请输入旧密码"
								clearable
							/>
						</el-form-item>
					</div>
					<div class="ModuleBoxBodyNewPassword">
						<el-form-item label="新密码" prop="NewPassword">
							<el-input
								type="password"
								v-model="Form.NewPassword"
								placeholder="请输入新密码"
								clearable
							/>
						</el-form-item>
					</div>
					<div class="ModuleBoxBodyAgainNewPassword">
						<el-form-item label="确认密码" prop="AgainNewPassword">
							<el-input
								type="password"
								v-model="Form.AgainNewPassword"
								placeholder="再次输入新密码"
								clearable
							/>
						</el-form-item>
					</div>
					<div class="ModuleBoxBodyKeyCode">
						<el-form-item label="操作密码" prop="KeyCode">
							<el-input 
								type="password"
								v-model="Form.KeyCode"
								placeholder="请输入操作密码"
								clearable
							/>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="ModuleBoxSubmitBtn">
				<el-button type="primary" @click="Admin_Update_Password_Submit()">提交保存</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>